import type { RouteRecordRaw } from "vue-router";
import EditSettingsPage from "./EditSettingsPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/settings",
    name: "settings",
    component: EditSettingsPage,
  },
];

export default routes;
